/**
 * LogRocket / telemetry redaction helpers (PLA-627 / PLA-801).
 *
 * Client-side redaction is the primary control for LogRocket: PHI must not
 * reach the vendor (SEC-199, T&C Sec 3). Provider identity (name, email,
 * NPI of the signed-in user) is not PHI and is not scrubbed; the session is
 * keyed by it (see logrocketIdentity.ts). What is scrubbed here is
 * credentials: LogRocket captures console output and uncaught exceptions in
 * addition to network activity, so any code that composes headers into
 * error messages or logs should scrub them first.
 */

/** Headers that carry credentials or identity — values are masked before capture. */
export const SENSITIVE_HEADERS = /^(authorization|cookie|set-cookie|x-api-key)$/i;

/** Mask sensitive header values in place. */
export const scrubHeaders = (headers: { [key: string]: string | null | undefined }): void => {
  for (const key of Object.keys(headers)) {
    if (SENSITIVE_HEADERS.test(key)) headers[key] = '[REDACTED]';
  }
};
